import { TERMS_ACCEPTANCE_PATH } from '@workspace/ui/lib';

// Define public routes that don't require authentication
export const PUBLIC_ROUTES = [];

// Define routes that should only be accessible to unauthenticated users
export const GUEST_ONLY_ROUTES = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/create-password',
  '/two-factor-auth',
  '/set-password',
  '/expired-activation',
  TERMS_ACCEPTANCE_PATH,
  '/.well-known/assetlinks.json',
  '/.well-known/apple-app-site-association',
];
